import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';
import ExclamationCircleSvg from '@/assets/ExclamationCircle.svg';

const ExclamationCircle = ({ size, variant, className }: IconProps) => (
  <img
    src={ExclamationCircleSvg}
    className={cn(iconVariant({ variant, size, className }))}
    aria-hidden="true"
    alt=""
  />
);

export default ExclamationCircle;
